import React from 'react';
import { siteConfig } from '../config/siteConfig';
import { motion } from 'framer-motion';
export function ProcessSection() {
  return <section className="w-full bg-brand-cream py-24 md:py-40" data-id="element-216">
      <div className="container mx-auto px-4 max-w-7xl" data-id="element-217">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-218">
          <span className="text-brand-navy font-bold tracking-widest text-sm uppercase mb-4 block" data-id="element-219">
            {siteConfig.process.eyebrow}
          </span>
          <h2 className="font-heading text-3xl md:text-[48px] font-bold text-brand-navy mb-6 leading-tight" data-id="element-220">
            {siteConfig.process.headline}
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground font-light" data-id="element-221">
            {siteConfig.process.subtext}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-222">
          {siteConfig.process.steps.map((step, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-white rounded-3xl p-10 shadow-xl shadow-brand-navy/5 border border-gray-100 relative group hover:-translate-y-2 transition-transform duration-300" data-id="element-223">
              <div className="absolute -top-5 -left-5 w-14 h-14 bg-brand-gold text-brand-navy rounded-full flex items-center justify-center font-serif font-bold text-2xl shadow-lg border-4 border-brand-cream" data-id="element-224">
                {idx + 1}
              </div>
              <div className="relative z-10 pt-4" data-id="element-225">
                <h3 className="text-2xl font-bold text-brand-navy mb-4" data-id="element-226">
                  {step.title}
                </h3>
                <p className="text-muted-foreground leading-relaxed font-light" data-id="element-227">
                  {step.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}